export default "__VITE_ASSET__cAA5gg0___"